var result = require("!!../../../../node_modules/html-loader/index.js?interpolate!./styling_texts_bd.html")
var H = require("hogan.js");
module.exports = function() {
var T = H.compile(result, {});
return T.render.apply(T, arguments); };


//////////////////
// WEBPACK FOOTER
// ./node_modules/mustache-loader!./node_modules/html-loader?interpolate!./src/components/guideline/templates/styling_texts_bd.html
// module id = 115
// module chunks = 0